module.exports = __webpack_public_path__ + "assets/img/AiFavorableCommentsBK.300aa576.jpg";